<ion-content class="cancel-table">
    <ng-container>
        <app-header [isParentPage]="false" [title]="'Cancel Order'"></app-header>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                     <ion-row>
                        <ion-col size="12" [sizeMd]="authService.user?.isCostCenterUser? 4:6">
                            <div>
                                <ion-input type="text"  [(ngModel)]="lastName" class="ion-text-left color-light" placeholder="{{authService.user?.isCostCenterUser ? 'Enter part of last name, stop code, or leave blank for all' : 'Enter part or all of last name, or leave blank for all'}}"   (keydown.enter)="onEnterKey($event)"></ion-input>
                                <ion-button *ngIf="!authService.user?.isCostCenterUser"  style=" margin-left:10px" color="gallaghergreen" class="btn-box-shadow" (click)="getDataByLastName()"><span>Show</span></ion-button>
                            </div>
                        </ion-col>
                        <ion-col size="12" [sizeMd]="3" *ngIf="authService.user?.isCostCenterUser">
                            <div>
                                <ng-select style="margin-right:10px;" placeholder="Select Cost Center" class="select" (change)="changeCostCenter($event)" (keydown.enter)="onEnterKey($event)">
                                    <ng-option *ngFor="let costCenter of loginDepts" value="{{costCenter.departmentCode}}">{{costCenter.departmentCode}}</ng-option>
                                </ng-select>
                                <ion-button color="gallaghergreen" class="btn-box-shadow" (click)="getDataCostCenter()"><span>Show</span></ion-button>
                            </div>
                        </ion-col>
                         <ion-col  size="12" size-md="2" style="padding-left:10px;margin-right: 1px;" *ngIf="authService.user?.isCostCenterUser">
                             <div>
                              <a   style="color:white; text-decoration: underline; cursor: pointer;"  class="text-link" (click)="getAllItem()"> View All</a>
                            </div>
                        </ion-col>
                    </ion-row>
                   
                </ion-grid>
            </ion-row>  
            <div class="page-loader" style="padding-top:10%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
            </div>
                <ion-row justify-content-center>
                <ion-col size="12" class="center-text">
                   <p>Click Employee ID to see that employee for last year.</p>
                    <p>Click Department ID to see that department for last 2 weeks.</p>
                    <p style="margin-bottom: 1px;">Click for printer friendly version.</p>
                </ion-col>
             </ion-row>
            <ion-row >
                <div *ngIf="!authService.user?.isWearer && !authService.user?.isCostCenterUser" class="ion-padding table-container">
                    <app-report-table [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements"></app-report-table>
                </div>
                <div *ngIf="authService.user?.isCostCenterUser" class="ion-padding table-container">
                    <app-cost-center-report-table  [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize"  [totalElements]="totalElements" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" [pageType]="authService.user?.isCostCenterUser ? 'cancelOrder' : ''"  (stopCodeClicked)="onStopCodeFilter($event)" (costCenterClicked)="onCostCenterFilter($event)"></app-cost-center-report-table>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>